<template>
  <enfold>
    <div class="issue-manage">
      <!-- 左侧的编辑计划组件 -->
      <edit-plan class="editplan" :plantype="plan_type" @thumbToList="thumbToList"></edit-plan>
      <!-- 中间播放计划组件 -->
      <template v-if="this.plan_type==0">
        <play-plan class="play-plan"></play-plan>
      </template>
      <template v-if="this.plan_type==1">
        <time-plan class="play-plan" :tl="TL_type"></time-plan>
      </template>
      <template v-if="this.plan_type==2">
        <urgency-plan class="play-plan"></urgency-plan>
      </template>
      <!-- 右侧节目预览组件 -->
      <show-preview class="show-preview"></show-preview>

    </div>
  </enfold>
</template>

<script>
import EditPlan from "./children/EditPlan.vue"
import PlayPlan from "./children/PlayPlan.vue"
import ShowPreview from "./children/ShowPreview.vue"
import TimePlan from "./children/TimePlan.vue"
import UrgencyPlan from "./children/UrgencyPlan.vue"
import Enfold from '@/components/basics/Enfold'
export default {
  name: 'PlayList',
  components: {
    EditPlan,
    PlayPlan,
    ShowPreview,
    TimePlan,
    UrgencyPlan,
    Enfold
  },
  data() {
    return {
      plan_type: null,
      TL_type: 0, // 0thumb/1list
    }
  },
  created() {
    const local_plan_type = localStorage.getItem('plan_type')
    //console.log(local_plan_type)
    if (local_plan_type) {
      this.plan_type = JSON.parse(local_plan_type)
    } else {
      this.plan_type = Number(this.$route.params.plan_type)
      localStorage.setItem("plan_type", JSON.stringify(this.$route.params.plan_type))
    }

  },
  methods: {
    thumbToList(type) {
      this.TL_type = type;
      // console.log(type);
    }
  },
  beforeDestroy() {
    localStorage.removeItem('plan_type')
  },
  destroyed() {
    this.$pstore.commit('clearitems')
  }

}
</script>

<style lang="scss" scoped>
.issue-manage {
  height: 100%;
  display: flex;
}

.edit-plan {
  flex-basis: 19%;
  min-width: 310px;
  height: 100%;
  box-sizing: content-box;
  border-right: 1px solid #dcdfe6;
}

.play-plan {
  flex-basis: 60%;
}

.show-preview {
  flex-basis: 21%;
}
</style>
